export enum PixType {
  TAX_IDENTIFIER = 1,
  EMAIL = 2,
  PHONE = 3,
  RANDOM = 4,
  BANK_DATA = 5,
}

export enum PixStatus {
  CLEARING_REGISTRATION_PENDING = 1,
  ACTIVE = 2,
  PENDING_PORTABILITY_DICT = 3,
  AWAITING_RETURN_PSP_DONOR = 4,
  PENDING_PORTABILITY_CONFIRMATION = 5,
  USER_CONFIRMATION_PENDING_PORTABILITY = 6,
  IDENTITY_VALIDATION_PENDING = 7,
  PENDING_CLAIM_CONFIRMATION = 8,
  USER_KEY_OWNERSHIP_VALIDATION_PENDING = 9,
  CLAIM_AWAITING_RETURN_PSP_DONOR = 10,
  PENDING_VALIDATION_COMPLETE_CLAIM = 11,
  EXCLUSION_PENDING = 20,
}
